module.exports = __webpack_public_path__ + "img/cross-patient-card.8a3f21d4.svg";